var script = {
  name: 'ScrollDetector',

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);

    if (this.checkWhenMounted) {
      if (this.delayCheckWhenMounted) {
        setTimeout(() => this.handleScroll(), this.delayCheckWhenMounted);
      } else {
        this.handleScroll();
      }
    }
  },

  props: {
    checkWhenMounted: {
      type: Boolean,
      default: true
    },
    delayCheckWhenMounted: {
      type: Number,
      default: null
    },
    nearRange: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      isInto: false,
      isEnter: false,
      isNear: false
    };
  },

  computed: {},
  methods: {
    handleScroll() {
      const rect = this.$refs.scrollDetector.getBoundingClientRect();
      const into = this.checkInto(rect);
      const enter = this.checkEnter(rect);
      const near = this.checkNear(rect);

      if (!this.isInto && into) {
        this.isInto = true;
        this.$emit('into-client-rect');
      } else if (this.isInto && !into) {
        this.isInto = false;
        this.$emit('out-client-rect');
      }

      if (!this.isEnter && enter) {
        this.isEnter = true;
        this.$emit('enter-client-rect');
      } else if (this.isEnter && !enter) {
        this.isEnter = false;
        this.$emit('leave-client-rect');
      }

      if (!this.isNear && near) {
        this.isNear = true;
        this.$emit('near-client-rect');
      } else if (this.isNear && !near) {
        this.isNear = false;
        this.$emit('far-client-rect');
      }
    },

    checkInto(rect) {
      const H = window.innerHeight;
      const W = window.innerWidth;
      const t = rect.top;
      const b = rect.bottom;
      const l = rect.left;
      const r = rect.right;
      const checkY = 0 <= t && H >= b || H >= b && 0 <= t;
      const checkX = 0 <= l && W >= r || W >= r && 0 <= l;
      return checkY && checkX;
    },

    checkEnter(rect) {
      const H = window.innerHeight;
      const W = window.innerWidth;
      const t = rect.top;
      const b = rect.bottom;
      const l = rect.left;
      const r = rect.right;
      const checkY = 0 <= b && H >= t || H >= t && 0 <= b;
      const checkX = 0 <= r && W >= l || W >= l && 0 <= r;
      return checkY && checkX;
    },

    checkNear(rect) {
      const EX_Y = Math.floor(window.innerHeight * this.nearRange);
      const EX_X = Math.floor(window.innerWidth * this.nearRange);
      const H = window.innerHeight;
      const W = window.innerWidth;
      const t = rect.top;
      const b = rect.bottom;
      const l = rect.left;
      const r = rect.right;
      const checkY = 0 - EX_Y <= b && H + EX_Y >= t || H + EX_Y >= t && 0 - EX_Y <= b;
      const checkX = 0 - EX_X <= r && W + EX_X >= l || W + EX_X >= l && 0 - EX_X <= r;
      return checkY && checkX;
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "scrollDetector"
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

// Import vue component

const install = function installScrollDetector(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('ScrollDetector', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
